import type { SystemStyleObject } from '@mui/system';
import type { Theme } from 'src/components/muiTheme/utils';

export const automationDragHighlightBg = (
  theme: Theme
): SystemStyleObject<Theme> => ({
  bgcolor: 'primary.lightest',
  ...theme.applyStyles('dark', {
    bgcolor: 'primary.4',
  }),
});

export const automationDragPlaceholderSx = (
  theme: Theme
): SystemStyleObject<Theme> => ({
  ...automationDragHighlightBg(theme),
  border: '1px dashed',
  borderColor: 'primary.main',
  borderRadius: 1,
});

export const automationDragCardSx = (theme: Theme): SystemStyleObject<Theme> => ({
  ...automationDragHighlightBg(theme),
  boxShadow: 'none',
});
